import React from 'react';
import GenericDialog from '../../../../components/dialog/GenericDialog';

import MeterModifyTab from './MeterModifyTab';
import MeterFaultyTab from './MeterFaultyTab';
import MeterEndTab from './MeterEndTab';

export default function MeterActionsDialog({
  open,
  onClose,
  initialData,
  onSubmit,
  defaultTabKey = 'modify',
}) {
  const tabs = [
    {
      key: 'modify',
      label: 'Change Meter',
      render: (helpers) => (
        <MeterModifyTab initialData={initialData} onSubmit={onSubmit} helpers={helpers} />
      ),
      actions: () => null,  
    },
    {
      key: 'faulty',
      label: 'Set Faulty',
      render: (helpers) => (
        <MeterFaultyTab initialData={initialData} onSubmit={onSubmit} helpers={helpers} />
      ),
      actions: () => null,
    },
    {
      key: 'end',
      label: 'End Meter',
      render: (helpers) => (
        <MeterEndTab initialData={initialData} onSubmit={onSubmit} helpers={helpers} />
      ),
      actions: () => null,
    },
  ];

  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title="Meter"
      tabs={tabs}
      defaultTabKey={defaultTabKey}
      maxWidth="xs"
    />
  );
}
